module.exports = __webpack_public_path__ + "img/114013.a75ad211.png";